// src/pages/HomePage.jsx
import IntroVideo from "../components/IntroVideo";
import VerticalBanner from "../components/VerticalBanner";
import Banner from "../components/Banner";
import Partners from "../components/Partners";
import ServicesActivities from "../components/ServicesActivities";
import RegistrationForm from "../components/RegistrationForm";
import PhoneCallButton from "../components/PhoneCallButton";
import ZaloButton from "../components/ZaloButton";
import ScrollToggleButton from "../components/ScrollToggleButton";
import Footer from "../components/Footer";
const HomePage = () => {
  return (
    <div className="home-page">
      <div className="section section-intro-video">
        <IntroVideo />
      </div>
      {/* Section form đăng ký */}
      <div className="section section-registration-form">
        <RegistrationForm />
      </div>
      {/* SectionBanner */}
      <div className="section section-banner">
        <Banner />
      </div>

      <div className="section section-intro-video">
        <VerticalBanner />
      </div>
      {/* Section các đối tác khách hàng */}
      <div className="section section-partners">
        <Partners />
      </div>

      {/* Section các hoạt động dịch vụ - đào tạo */}
      <div className="section section-services-activities">
        <ServicesActivities />
      </div>
      {/* Footer Section */}
      <div className="section section-footer">
        <Footer />
      </div>

      {/* Nút gọi điện thoại */}
      <ScrollToggleButton />
      <ZaloButton phoneNumber="0704888009" />
      <PhoneCallButton phoneNumber="0704888009" />
    </div>
  );
};

export default HomePage;
